const transferSteps = [
  'Create a backup with the built-in backup tool on your current computer',
  'Install Family Tree Maker on the new machine',
  'Restore from your backup file',
  'Confirm media and person records transferred',
  'Activate your license on the new device',
];

const keyFeatures = [
  { label: 'Pedigree View', desc: 'Classic ancestry layout' },
  { label: 'Family View', desc: 'Households & relationships' },
  { label: 'Person List', desc: 'Jump to anyone quickly' },
  { label: 'Individual Details', desc: 'Full profiles per person' },
  { label: 'Media Gallery', desc: 'Photos & documents together' },
  { label: 'Research Log', desc: 'Track sources & findings' },
];

export default function AdditionalSections() {
  return (
    <>
      <section className="t7-section t7-section--wash">
        <div className="container grid md:grid-cols-2 gap-8 md:gap-12 items-start">
          <div className="t7-head t7-head--rail mb-0">
            <p className="t7-kicker">Cross-platform</p>
            <h2 className="t7-title">Smart solutions for your family history</h2>
          </div>
          <div className="space-y-4 pt-1">
            <p className="text-[#4d5c54] text-base md:text-lg leading-relaxed">
              Moving between Windows and Mac, or upgrading hardware? Migration tools carry your tree,
              media, and notes so nothing important is left behind.
            </p>
            <p className="text-[#4d5c54] leading-relaxed">
              Pick up exactly where you stopped—on whichever platform you choose next.
            </p>
          </div>
        </div>
      </section>

      <section className="t7-section t7-section--white">
        <div className="container">
          <div className="t7-head t7-head--rail">
            <p className="t7-kicker">Migration</p>
            <h2 className="t7-title">Transfer FTM to a new computer</h2>
            <p className="t7-lead">
              A straightforward path to move Family Tree Maker safely—backup, install, restore, verify.
            </p>
          </div>

          <ol className="max-w-3xl space-y-0 border-l border-[#c5d9cb] ml-2 sm:ml-3 md:ml-4">
            {transferSteps.map((step, i) => (
              <li key={step} className="relative pl-7 sm:pl-8 md:pl-10 pb-6 sm:pb-8 last:pb-0">
                <span className="absolute -left-[11px] sm:-left-[13px] top-0 flex h-5 w-5 sm:h-6 sm:w-6 items-center justify-center rounded-full bg-[#166534] text-white text-[10px] sm:text-xs font-bold">
                  {i + 1}
                </span>
                <p className="text-[#14201a] text-sm sm:text-base font-medium leading-relaxed pt-0.5">{step}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="t7-section t7-section--wash">
        <div className="container max-w-3xl">
          <div className="t7-head t7-head--center">
            <p className="t7-kicker">Overview</p>
            <h2 className="t7-title t7-title--center">What is Family Tree Maker?</h2>
          </div>
          <div className="space-y-5 text-center px-1">
            <p className="text-[#4d5c54] text-base md:text-lg leading-relaxed">
              Discover, organize, and share your family story with research tools, clear structure,
              and charting that looks as good as it works.
            </p>
            <p className="text-[#4d5c54] text-sm sm:text-base leading-relaxed">
              Build detailed trees, attach media, create reports, and sync with FamilySearch—smart
              matching and cloud backup keep the journey smoother.
            </p>
          </div>
        </div>
      </section>

      <section className="t7-section t7-section--white">
        <div className="container grid md:grid-cols-2 gap-8 md:gap-10 items-start md:items-center">
          <div>
            <div className="t7-head t7-head--rail mb-0">
              <p className="t7-kicker">Stay current</p>
              <h2 className="t7-title">Family Tree Maker upgrade</h2>
            </div>
          </div>
          <div className="space-y-4">
            <p className="text-[#4d5c54] text-base md:text-lg leading-relaxed">
              Upgrading unlocks stronger charting, media tools, and tighter FamilySearch integration—
              while keeping the tree you already built.
            </p>
            <p className="text-[#4d5c54] text-sm sm:text-base leading-relaxed">
              Expect clearer reports, smoother performance, and access to the latest features so your
              research stays ahead.
            </p>
          </div>
        </div>
      </section>

      <section className="t7-section t7-section--wash">
        <div className="container">
          <div className="t7-head t7-head--rail">
            <p className="t7-kicker">At a glance</p>
            <h2 className="t7-title">Key features</h2>
            <p className="t7-lead">Core views and tools genealogists use every day.</p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-8">
            {keyFeatures.map((feature) => (
              <div key={feature.label} className="flex gap-4">
                <span className="mt-1 h-8 w-[3px] shrink-0 bg-[#15803d]" aria-hidden="true" />
                <div>
                  <p className="font-serif text-lg text-[#14201a] mb-1">{feature.label}</p>
                  <p className="text-sm text-[#4d5c54]">{feature.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
